import { Box, styled } from '@mui/material';
import { GuaranteedPlanPayment } from 'new/modules/EnrollPage/types';
import { GPP_PERCENTAGE_PRICING } from 'new/modules/ManagePlans/constants';
import findRoute from 'new/routing/routes';
import React from 'react';
import { LandingPageCommonProps } from '../../types';
import {
  commonLandingPageStyles,
  landingPageBtn,
  sectionLandingPageStyles,
} from '../../styles';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import { Link } from 'react-router';

const Wrapper = styled(Box)(({ theme }) => ({
  '&.isNewTheme': {
    ...commonLandingPageStyles,
  },
  ...landingPageBtn,
  ...sectionLandingPageStyles,
  textAlign: 'center',
  '.loginLink, .gppInfo': {
    marginTop: '2rem',
    fontSize: '0.9rem',
    fontStyle: 'italic',
  },
  '.changeAgree': {
    fontSize: '.8rem',
    color: theme.palette.grey[600],
  },
  '&.isClassicTheme': {
    '.btn': {
      fontFamily: 'Barlow Semi Condensed',
      fontWeight: 600,
      padding: '1rem 1.5rem',
      fontSize: '0.875rem',
      borderRadius: 0,
      boxShadow: 'none',
    },
  },
}));

type Props = {
  dentistInfoId: number;
  disableEnrollment: boolean;
  gpp?: GuaranteedPlanPayment;
  isNewTheme: boolean;
  groupCode?: string | null;
  phone: string;
} & LandingPageCommonProps;

const JoinMiddleSection: React.FC<Props> = ({
  dentistInfoId,
  disableEnrollment,
  colorTwoHex,
  gpp,
  isNewTheme,
  groupCode,
  phone,
  groupInfo,
  bcToken,
}) => {
  const intl = useIntl();
  const offersGPP =
    gpp && gpp.active && !!gpp.approvalDate && !gpp.gppMemberWaive;
  return (
    <Wrapper className={cx({ isClassicTheme: !isNewTheme, isNewTheme })}>
      <div className="changeAgree">
        <i>
          {intl.formatMessage({
            id: 'signup.externalLanding.changeAgreeLabel',
          })}
        </i>
      </div>
      {!disableEnrollment ? (
        <Link
          className="btn"
          to={`${
            findRoute('ExternalPatientSignup').path
          }?officeId=${dentistInfoId}${
            groupCode == null || groupCode == undefined
              ? ''
              : '&groupCode=' + groupCode
          }${
            bcToken == null || bcToken == undefined ? '' : '&token=' + bcToken
          }${
            groupInfo == null || groupInfo == undefined
              ? ''
              : '&groupInfo=' + groupInfo
          }`}
          style={{
            backgroundColor: colorTwoHex,
            padding: '10px',
          }}
        >
          {intl.formatMessage({
            id: 'signup.externalLanding.hero.joinOurMembershipPlan.button',
          })}
        </Link>
      ) : (
        <div>
          <h3>
            {intl.formatMessage(
              {
                id: 'label.callAbout',
              },
              { phone: phone },
            )}
          </h3>
        </div>
      )}
      <div className="loginLink">
        {intl.formatMessage({ id: 'label.alreadyAMember' })}{' '}
        <a
          href={'/accounts/login?id=' + dentistInfoId}
          style={{ color: colorTwoHex }}
        >
          {intl.formatMessage({ id: 'label.login' })}
        </a>
      </div>

      {offersGPP && (
        <div className="gppInfo">
          {intl.formatMessage(
            { id: 'signup.externalLanding.gppInfo' },
            { percentage: GPP_PERCENTAGE_PRICING },
          )}
        </div>
      )}
    </Wrapper>
  );
};

export default JoinMiddleSection;
